<div class="unsubscribe-container">
  <h4 class="unsubscribe-title">Enter the email address that you wish to unsubscribe from this mailing list</h4>

  <form [formGroup]="unsubscribeForm" (ngSubmit)="onUnsubscribe()" class="unsubscribe-form">
    <div class="form-group">
      <label for="email" class="email-label">Email Address</label>
      <input
        type="email"
        id="email"
        formControlName="email"
        class="email-input"
        placeholder="Enter your email address"
        [class.error]="email?.invalid && email?.touched">
      <div class="error-message" *ngIf="email?.invalid && email?.touched">
        <span *ngIf="email?.errors?.['required']">Email address is required</span>
        <span *ngIf="email?.errors?.['email']">Please enter a valid email address</span>
      </div>
    </div>

    <div class="message-container" *ngIf="showMessage">
      <div class="message" [ngClass]="{'success': isSuccess, 'error': !isSuccess}">
        {{ messageText }}
      </div>
    </div>

    <div class="subscribe-again-container" *ngIf="showMessage && isSuccess && messageText === 'You are unsubscribed!'">
      <button
        type="button"
        class="subscribe-again-btn"
        (click)="onSubscribe()"
        [disabled]="isSubscribed">
        {{ isSubscribed ? 'Subscribing...' : 'Subscribe again' }}
      </button>
    </div>

    <div class="button-group">
      <button type="submit" class="unsubscribe-btn" [disabled]="unsubscribeForm.invalid">Unsubscribe</button>
      <button type="button" class="cancel-btn" (click)="onCancel()">Cancel</button>
    </div>
  </form>
</div>
